module.exports = __webpack_public_path__ + "img/ken.cff0e26e.jpg";